import React, { Component } from 'react';
import twitterImg from '../images/twitter.png'
import facebookImg from '../images/facebook.png'
import linkedinImg from '../images/linkedin.png'
import instagramImg from '../images/instagram.png'
import $ from "jquery"

export default class footer extends Component {
  componentDidMount() {
    $(".btn-scroll-top").click(function(){
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    });
  }
render() {
    return (
      
    <footer>	
      <div className="container">	
          <div className="row">	
              <div className="col-md-6 col-sm-6">	
                  {/* <h4>	Become a Member Today</h4>
                  <p>	<strong>Free Career Guidance	</strong></p> */}
                  <p style={{fontSize:"16px",marginLeft:"18px"}}>	With Ivanooo, you just don't go through hundreds of courses. Narrow down choices. Avoid pitfalls and make better decisions.</p>
                  <div className='col-md-12 mt-5'>
                    <a href="/assesment/apply" className="btn-theme">Get Started</a>
                  </div>
              </div>
              <div className="col-md-6 col-sm-6">	
                <div className="footer-right">
                  
                  <div className="footer-socials">	
                      <a href="https://www.facebook.com/ivanooolearning"><img src={facebookImg} alt="" /></a>
                      <a href="https://twitter.com/ivanooolearning"><img src={twitterImg} style={{width:"38px"}} alt="" /></a>
                      <a href="https://www.linkedin.com/company/ivanooo"><img src={linkedinImg} alt="" /></a>
                      <a href="https://instagram.com/ivanooo.learning"><img src={instagramImg} alt="" /></a>
                  </div>		

                  <ul className="footer-menu">	
                      <li><a href="/privacy-policy">Privacy Policy</a></li>
                      <li><a href="/about">about</a></li>
                      <li><a href="/contact">Contacts</a></li>
                      <li><a href="#">Terms of Use</a></li>
                  </ul>	

                </div>
              </div>		
          </div>			
          <div className='col-md-12 copyright-outer'>
            <p className="copyright">All © Rights Reserved | Ivanooo - 2021</p>
          </div>	
      </div>	
      <a className="btn-scroll-top" data-scroll="">
				<svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M9.84016 0.540385L9.5126 0.210545C9.40951 0.107536 9.27235 0.0507876 9.12577 0.0507876C8.97926 0.0507876 8.84194 0.107536 8.73885 0.210545L5.00224 3.94732L1.26131 0.206399C1.15838 0.10339 1.02107 0.0467224 0.87456 0.0467224C0.728055 0.0467224 0.590655 0.10339 0.487646 0.206399L0.160001 0.534206C-0.0533338 0.747379 -0.0533338 1.09462 0.160001 1.30779L4.61402 5.77783C4.71695 5.88075 4.8541 5.95327 5.00191 5.95327H5.00362C5.1502 5.95327 5.28736 5.88067 5.39029 5.77783L9.84016 1.3199C9.94325 1.21698 9.99984 1.07567 10 0.929169C10 0.782582 9.94325 0.643231 9.84016 0.540385Z" fill="currentColor"></path>
				</svg>
			</a>
    </footer>
    )
  }
}



// WEBPACK FOOTER //
// ./src/layout/footer.jsx